import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PictureViewerService {
  private _showPictureViewer = new Subject<any>();
  showPictureViewer$ = this._showPictureViewer.asObservable();
  constructor() { }

  open(images: string[], index: number) {
    this._showPictureViewer.next({ images, index })
  }
}
